export default {
	styleOverrides: {
		root: {
			minWidth: '28px',
			padding: '6px',
			borderRadius: '50%',
			color: 'currentColor',
		},
	},
};
